/*
 * @Author: jingqiwei
 * @Date: 2020-12-10
 * @LastEditTime: 2019-11-11
 * @Description: 地址相关接口
 */
import $store from '@/store';
import request from '../utils/request';
const base = '/web/address';

// 获取我的地址
export const getMyAddress = (params) => {
  return request.post(`${base}/list`, params);
};

// 删除地址
export const delMyAddress = (params) => {
  return request.post(`${base}/delete`, params);
};

// 获取我的地址
export const getMyDefaultAddress = (params) => {
  return request.post(`${base}/getDefaultAddressByUid?uid=${$store.getters.uid}`, params);
};

// 保存地址 也可用作设为为默认地址
export const saveMyAddress = (params) => {
  return request.post(`${base}/save`, params);
};



// WEBPACK FOOTER //
// src/api/address.js